import { z } from 'zod';

export const FertilizerTemplateSchema = z.object({
  id: z.number().int().positive(),
  company_id: z.number().int().positive(),
  template_name: z.string().min(1).max(500),
  created_at: z.string(),
  updated_at: z.string(),
  created_by: z.string().nullable().optional(),
  updated_by: z.string().nullable().optional(),
});

export const FertilizerTemplateDetailSchema = z.object({
  id: z.number().int().positive().optional(),
  template_id: z.number().int().positive().optional(),
  company_id: z.number().int().positive().optional(),
  product: z.number().int().nullable().optional(),
  product_name: z.string().max(500).nullable().optional(),
  rate: z.number().nullable().optional(),
  unit_type: z.string().max(100).nullable().optional(),
  cost_per_unit: z.number().nullable().optional(),
  rate_per_hectre: z.number().nullable().optional(),
  fertiliser_type: z.string().max(255).nullable().optional(),
  withhold_days: z.number().int().nullable().optional(),
});

export const FertilizerTemplateCreateSchema = z.object({
  template_name: z.string().min(1).max(500),
  details: z.array(FertilizerTemplateDetailSchema).optional().default([]),
});

export const FertilizerTemplateUpdateSchema = z.object({
  template_name: z.string().min(1).max(500),
  details: z.array(FertilizerTemplateDetailSchema).optional().default([]),
  deleted_detail_ids: z.array(z.number().int()).optional().default([]),
});

export const FertilizerTemplateListQuerySchema = z.object({
  search: z.string().optional(),
  page: z.coerce.number().int().positive().optional().default(1),
  per_page: z.coerce.number().int().positive().max(500).optional().default(25),
});

export type FertilizerTemplate = z.infer<typeof FertilizerTemplateSchema>;
export type FertilizerTemplateDetail = z.infer<typeof FertilizerTemplateDetailSchema>;
export type FertilizerTemplateCreate = z.infer<typeof FertilizerTemplateCreateSchema>;
export type FertilizerTemplateUpdate = z.infer<typeof FertilizerTemplateUpdateSchema>;
export type FertilizerTemplateListQuery = z.infer<typeof FertilizerTemplateListQuerySchema>;
